import React, { Component } from 'react';
import './css/main.css';

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import Paragraph from './layout/Paragraph';
import TextBlock from './layout/TextBlock';

// import ImageGridFront from './layout/portfolio/ImageGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import WarpLarge from './layout/warp/WarpLarge';

import DeviceGridCustom from './layout/portfolio/DeviceGridCustom';
import DeviceMockupVideo from './layout/portfolio/DeviceMockupVideo';
import DeviceMockup from './layout/portfolio/DeviceMockup';

import VideoGridx1 from './layout/portfolio/VideoGridx1';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';
import ImageGridx3 from './layout/portfolio/ImageGridx3';
import ImageGridFront from './layout/portfolio/ImageGridFront';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';

import VideoGridFront from './layout/portfolio/VideoGridFront';

import PenIcon from './asset/PenIcon';
import Front from './img/ittybittyapps/reveal.mp4';

// Reveal
import Reveal_1 from './img/aia/medals@2x.png';
import Reveal_2 from './img/ittybittyapps/RevealIcon2@2x.png';
import fitnessDevice from './img/aia/AIA_loading.mp4';
import activateGoal from './img/aia/AIA_loading.mp4';
import aiaIcon from './img/aia/aia_icons@2x.png';


// UX-wish
import monopoly from './img/aia/monopoly@2x.jpg';
import flowSketch from './img/aia/flowsketch@2x.jpg';

// SnapSendSolve
import Snapshot_1 from './img/ittybittyapps/snapshot-device.png';
import Snapshot_2 from './img/ittybittyapps/snapshot-sample1.png';
import Snapshot_3_vid from './img/ittybittyapps/snapshot-sample3.mp4';

// Summary
const companyInfo = {
  title: "AIA Vitality",
  name: "Designing a mobile customer experience for a new wireless operator",
  themeColor: "#181818",
  themeTextColor: "#ffffff",
  frontImage: Front,
  role: "Senior Designer",
  fields: "iOS Apps, Mac Apps, Consulting",
  time: "Feb 2015 – Mar 2017",
}

// Background of the project
const casestudy_1 = {
  title: "Background",
  paragraph: "AIA Vitality is a health and wellness program. The program was designed to help the members by encouraging healthy life choices, such as exercise and balanced diet. However, the digital experience was still heavily focused on web. The team of Itty Bitty Apps started working on a fresh new app for them. My role was to work as a lead designer to research and create new mobile app.",
}

// Background of the project
const casestudy_2 = {
  title: "The biggest challenge was the data.",
  paragraph: "Unlike common projects, there were too many layers between the app and the server. Unfortunately, it also meant the general speed of the app won't be fast until they have a better API. Building a new product with latest tech under slow API was the most difficult challenge we ever had.",
}

// Background of the project
const casestudy_3 = {
  paragraph: "The biggest goal of UX design was to temper the frustration from slowness. It reminded me of flight booking apps like Expedia. All of them have fun loading animations because it takes a long time to scan available flights around the world! Turning something slow into something cool was the most creative solution designer can contribute. Eventhough I wish everything could have been more faster, I can't deny that I really enjoyed creating lots of fun animations.",
}

const casestudy_4 = {
  title: "Defining strategic product identity.",
  paragraph: "The concept of a new health and wellness reward program under life insurance company can be skeptical for general audience. The visual identity of AIA Vitality had to be stragetic to reduce those misunderstanding yet earning the trust from a world famous brand.",
}

const casestudy_5 = {
  paragraph: "To solve the issue, I designed the marketing materials to look more 'AIA' by emphasize the color and key symbole from the insurance company. On the other hand, once you launched the app, the visual becomes all about the benefits and the activities to earn points. The gift vouchers, the gold medal, and the health test icons! It wasn't a easy decision compared to paint bucket the brand colour everywhere. However, the members insisted he product became a lot easy to understand after we made the change.",
}

const casestudy_6 = {
  title: "Commonsense was the best tool.",
  paragraph: "One of the most memorable part of this project was that we organised lots of testings to verify an idea. From really low fidelity paper sketch, silly monopoly idea auction, to ultra high-fidelity Framer mockup.",
}

const caseStudy_7 = {
  paragraph: "We organised ad-hoc user testing, showing my Framer prototype to 5-6 people outside of the project. The testers knew nothing about the mobile project, so their behaviour was more closer to actual users."
}

class CasestudyAIAVitality extends Component {
  render() {
    return (
      <div>
        <Navigation />
        {/*Front page*/}
        <VideoGridFront first={fitnessDevice} title={companyInfo.title} themeColor={companyInfo.themeColor} textColor={companyInfo.themeTextColor}/>
        {/*Position summary*/}
        <Paragraph heading={casestudy_1.title} paragraph={casestudy_1.paragraph}/>

        {/*----- About Speed challange ------*/}
        <Paragraph heading={casestudy_2.title} paragraph={casestudy_2.paragraph}/>
        <VideoGridx1 first={fitnessDevice} false/>
        <TextBlock paragraph={casestudy_3.paragraph}/>

        {/*----- About Visual identity ------*/}
        <Paragraph heading={casestudy_4.title} paragraph={casestudy_4.paragraph}/>
        <ImageGridx1 first={Reveal_1} false/>
        <TextBlock paragraph={casestudy_5.paragraph}/>
        <GalleryGridx1 first={aiaIcon} false/>

        {/*----- About User testing ------*/}
        <Paragraph heading={casestudy_6.title} paragraph={casestudy_6.paragraph}/>
        <GalleryGridx2
            first={flowSketch} second={monopoly}
            false/>
        <Paragraph paragraph={caseStudy_7.paragraph}/>
        <ImageGridx2 first="https://cdn.dribbble.com/users/124935/screenshots/3393638/claiming_example.gif" second="https://cdn.dribbble.com/users/124935/screenshots/3394171/transition_example.gif"
       false/>

        <Footer/>
      </div>
    );
  }
}

export default CasestudyAIAVitality;



// WEBPACK FOOTER //
// ./src/CasestudyAIAVitality.js